import React, { useState, useEffect } from "react";
import {
  Radio,
  Button,
  Input,
  Form,
  Select,
  Checkbox,
  Table,
  Pagination,
  Modal,
  message,
  Divider,
} from "antd";
import { Link } from "react-router-dom";
import "./roleManagement.less";
import { axiosPost } from "@/server/index";
import common from "@/public/common";
import { getCookieNew, getSuulierData } from "@/public/utils";
const FormItem = Form.Item;
const { Option } = Select;
const RoleManagement = (props) => {
  const [searchForm] = Form.useForm();
  const [page, setPage] = useState({
    pageindex: 1,
    pagesize: 10,
  });
  const [helpVisiable, setHelpVisiable] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [pageInfo, setPageInfo] = useState("");
  const [addRoleVisible, setAddRoleVisible] = useState(false);
  const [rewriteRoleVisible, setRewriteRoleVisible] = useState(false);
  const [addOKTipVisible, setAddOKTipVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentAddRole, setCurrentAddRole] = useState({});

  const roleColumns = [
    {
      title: "角色名称",
      dataIndex: "rolename",
      key: "rolename",
      width: 200,
    },
    {
      title: "角色分组",
      dataIndex: "groupname",
      key: "groupname",
      width: 200,
    },
    {
      title: "状态",
      key: "deleted",
      width: 200,
      render: (text) => {
        return text.deleted == true ? "停用" : "启用";
      },
    },
    {
      title: "操作",
      key: "option",
      width: 200,
      render: (text, record) => {
        return handleOption(text, record);
      },
    },
  ];

  const [addRoleReqData, setAddRoleReqData] = useState({
    rolename: "",
    groupname: "",
    deleted: 0,
    createname: "",
  });

  const [rewriteReqData, setRewriteReqData] = useState({
    roleid: "",
    rolename: "",
    groupname: "",
    deleted: "",
    modifyname: "",
  });

  useEffect(() => {
    getRoleList();
  }, [page]);

  // 获取角色列表数据
  const getRoleList = () => {
    setLoading(true);
    const searchFormValues = searchForm.getFieldsValue();
    const requestData = {
      ...page,
      ...searchFormValues,
      roleType: "supplier",
      ...getSuulierData(),
    };
    axiosPost(
      common.eurekaUrlDic + "/permission/rolelist/query",
      requestData,
    ).then((res) => {
      if (res.status === 200) {
        let { data } = res;
        setRoleList(data.datas);
        setPageInfo(data.page);
        setLoading(false);
      }
    });
  };

  const handleOption = (text, record) => {
    let setUserobj = {
      pathname: "/main/roleManagement/usersSetting",
      state: { fromDashboard: text, item: record },
    };
    let setRight = {
      pathname: "/main/roleManagement/permissionSettings",
      state: { fromDashboard: text },
    };
    let optionHtml =
      record.isUserCanDelete == false ? (
        <p style={{ color: "gray" }}>
          <span style={{ verticalAlign: "middle" }}>编辑&nbsp;&nbsp;</span>
          <span style={{ verticalAlign: "middle" }}>设置权限&nbsp;&nbsp;</span>
          <span style={{ verticalAlign: "middle", cursor: "pointer" }}>
            设置用户&nbsp;&nbsp;
          </span>
        </p>
      ) : (
        <p style={{ color: "#1890ff" }}>
          <span
            onClick={() => {
              openRewriteModal(text);
            }}
            style={{ verticalAlign: "middle", cursor: "pointer" }}
          >
            编辑&nbsp;&nbsp;
          </span>
          <span style={{ verticalAlign: "middle", cursor: "pointer" }}>
            <Link to={setRight}>设置权限&nbsp;&nbsp;</Link>
          </span>
          <span style={{ verticalAlign: "middle", cursor: "pointer" }}>
            <Link to={setUserobj}>设置用户&nbsp;&nbsp;</Link>
          </span>
        </p>
      );
    return optionHtml;
  };

  // 查询
  const handleSearch = () => {
    setPage((prev) => ({
      ...prev,
      pageindex: 1,
    }));
  };

  // 分页
  const onPaginationChange = (value, size) => {
    setPage({
      pageindex: value,
      pagesize: size,
    });
  };

  // 新增角色-打开弹窗
  const handleOpenAddRole = () => {
    let userInfo = getCookieNew("adminName")
      ? JSON.parse(getCookieNew("adminName"))
      : JSON.parse(localStorage.getItem("otheradminName"));
    setAddRoleReqData((prev) => ({
      ...prev,
      createname: userInfo.account,
    }));
    setAddRoleVisible(true);
  };

  // 新增角色-提交按钮
  const handlAddRoleeOk = () => {
    if (
      addRoleReqData.rolename === "" ||
      addRoleReqData.groupname === "" ||
      addRoleReqData.deleted === "" ||
      addRoleReqData.createname === ""
    ) {
      message.error("请将角色信息填写完整");
      return;
    }
    axiosPost(common.eurekaUrlDic + "/permission/role/add", {
      ...addRoleReqData,
      roleType: "supplier",
      ...getSuulierData(),
    }).then((res) => {
      if (res.status === 200) {
        let queryReqData = {
          rolename: addRoleReqData.rolename,
          roleType: "supplier",
          ...getSuulierData(),
        };
        axiosPost(
          common.eurekaUrlDic + "/permission/rolelist/query",
          queryReqData,
        ).then((res) => {
          if (res.status === 200) {
            let { data } = res;
            setCurrentAddRole(data.datas[0]);
            setAddOKTipVisible(true);
            getRoleList();
            handleAddRoleCancel();
          }
        });
      } else {
        message.error("添加失败");
      }
    });
  };

  // 新增角色-取消按钮/关闭弹窗
  const handleAddRoleCancel = () => {
    setAddRoleVisible(false);
    setAddRoleReqData({
      rolename: "",
      groupname: "",
      deleted: 0,
      createname: "",
    });
  };

  // 新增角色-表单（角色名称/角色状态）
  const handleAddInputChange = (value) => {
    setAddRoleReqData((prev) => ({
      ...prev,
      [value.target.name]: value.target.value,
    }));
  };

  // 新增角色-选择角色分组
  const handleAddSelectChange = (value) => {
    setAddRoleReqData((prev) => ({
      ...prev,
      groupname: value,
    }));
  };

  // 新增角色后的成功提示弹窗-取消
  const addOKTipCancel = () => {
    setAddOKTipVisible(false);
  };

  // 编辑修改角色-打开弹窗
  const openRewriteModal = (data) => {
    let userInfo = getCookieNew("adminName")
      ? JSON.parse(getCookieNew("adminName"))
      : JSON.parse(localStorage.getItem("otheradminName"));
    setRewriteReqData({
      roleid: data.roleid,
      rolename: data.rolename,
      groupname: data.groupname,
      oldname: data.rolename,
      deleted: data.deleted ? 1 : 0,
      modifyname: userInfo.account,
    });
    setRewriteRoleVisible(true);
  };

  // 编辑修改角色-取消按钮/关闭弹窗
  const handlelRewriteRoleCancel = () => {
    setRewriteReqData({
      roleid: "",
      rolename: "",
      groupname: "",
      deleted: "",
      modifyname: "",
    });
    setRewriteRoleVisible(false);
  };

  // 编辑修改角色-表单（角色名称/角色状态）
  const handlelRewriteInputChange = (value) => {
    setRewriteReqData((prev) => ({
      ...prev,
      [value.target.name]: value.target.value,
    }));
  };

  // 编辑修改角色-选择角色分组
  const handlelRewriteSelectChange = (value) => {
    setRewriteReqData((prev) => ({
      ...prev,
      groupname: value,
    }));
  };

  // 编辑修改角色-提交按钮
  const handlRewriteRoleeOk = () => {
    if (
      rewriteReqData.rolename === "" ||
      rewriteReqData.groupname === "" ||
      rewriteReqData.deleted === "" ||
      rewriteReqData.modifyname === ""
    ) {
      message.error("请将角色信息填写完整");
      return;
    }
    axiosPost(common.eurekaUrlDic + "/permission/role/update", {
      ...rewriteReqData,
      roleType: "supplier",
      ...getSuulierData(),
    }).then((res) => {
      if (res.status === 200) {
        message.success("修改成功");
        getRoleList();
        handlelRewriteRoleCancel();
      } else {
        message.error("修改失败");
      }
    });
  };

  // 帮助中心弹框
  const helpModalChange = () => {
    setHelpVisiable(!helpVisiable);
  };

  const options = [
    { label: "启用", value: 0 },
    { label: "停用", value: 1 },
  ];

  const setRightobj = {
    pathname: "/main/roleManagement/permissionSettings",
    state: { fromDashboard: currentAddRole },
  };

  return (
    <div className="roleManagement_wrap">
      <div className="search">
        <div className="content">
          <Form form={searchForm} layout="inline">
            <Form.Item name="rolename">
              <Input placeholder="角色名称" className="input" allowClear />
            </Form.Item>
            <Form.Item name="groupname">
              <Select
                allowClear
                placeholder="角色分组"
                style={{ width: 150, marginRight: 20 }}
              >
                <Option value="人事">人事</Option>
                <Option value="运营">运营</Option>
                <Option value="客服">客服</Option>
                <Option value="采购">采购</Option>
                <Option value="仓储">仓储</Option>
                <Option value="批发">批发</Option>
                <Option value="技术">技术</Option>
                <Option value="管理员">管理员</Option>
                <Option value="财务">财务</Option>
                <Option value="质量">质量</Option>
                <Option value="品牌方">品牌方</Option>
              </Select>
            </Form.Item>
            {/* <Form.Item name='roleType'> 
              <Select allowClear placeholder='角色类型' style={{width:100}} options={[{
                label:'系统角色',
                value:'system'
              },{ label:'供应商角色',
                value:'supplier'}]}/>
            </Form.Item> */}
            <Form.Item label="状态" name="deleted" initialValue={[]}>
              <Checkbox.Group options={options} allowClear />
            </Form.Item>

            <Form.Item>
              <Button
                shape="round"
                onClick={handleSearch}
                type="primary"
                style={{ marginLeft: 20 }}
              >
                查询
              </Button>
            </Form.Item>
            <Form.Item>
              <Button
                shape="round"
                onClick={handleOpenAddRole}
                type="primary"
                style={{ marginLeft: 16 }}
              >
                添加角色
              </Button>
            </Form.Item>
          </Form>
          <span
            style={{
              float: "right",
              color: "#1890ff",
              cursor: "pointer",
              marginTop: "10px",
            }}
            onClick={helpModalChange}
          >
            帮助?
          </span>
        </div>
      </div>
      <div className="body">
        <FormItem>
          <Table
            loading={loading}
            columns={roleColumns}
            dataSource={roleList}
            pagination={false}
            bordered={false}
            rowKey={(record) => record.rolename}
          />
        </FormItem>
        <div className="pagination_wrap">
          <span>
            共 <span>{pageInfo.rowCount || 0}</span> 条记录
          </span>
          <Pagination
            current={page.pageindex}
            total={pageInfo.rowCount || 0}
            pageSize={page.pagesize}
            onChange={onPaginationChange}
            showSizeChanger
          />
        </div>
      </div>
      {/* 添加角色弹窗 */}
      <Modal
        title="添加角色"
        open={addRoleVisible}
        onCancel={handleAddRoleCancel}
        footer={[
          <Button shape="round" type="primary" onClick={handlAddRoleeOk}>
            确认
          </Button>,
          <Button shape="round" onClick={handleAddRoleCancel}>
            取消
          </Button>,
        ]}
        className="addRole_wrap"
        destroyOnClose={true}
      >
        <FormItem>
          <div className="item">
            <span>
              <b style={{ color: "red" }}>*</b>角色名称：
            </span>
            <Input
              onChange={(value) => {
                handleAddInputChange(value);
              }}
              placeholder="请输入角色名称"
              name="rolename"
              className="input"
            />
          </div>
        </FormItem>
        <FormItem>
          <div className="item">
            <span>
              {" "}
              <b style={{ color: "red" }}>*</b>角色分组：
            </span>
            <Select
              placeholder="请选择角色分组"
              style={{ width: 300, marginRight: 20 }}
              onChange={(value) => {
                handleAddSelectChange(value);
              }}
            >
              <Option value="人事">人事</Option>
              <Option value="运营">运营</Option>
              <Option value="客服">客服</Option>
              <Option value="采购">采购</Option>
              <Option value="仓储">仓储</Option>
              <Option value="批发">批发</Option>
              <Option value="技术">技术</Option>
              <Option value="管理员">管理员</Option>
              <Option value="财务">财务</Option>
              <Option value="质量">质量</Option>
              <Option value="品牌方">品牌方</Option>
            </Select>
          </div>
        </FormItem>
        <FormItem>
          <div className="item">
            <span>
              {" "}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b style={{ color: "red" }}>*</b>状态：
            </span>
            <Radio.Group
              name="deleted"
              onChange={(value) => {
                handleAddInputChange(value);
              }}
              value={addRoleReqData.deleted}
            >
              <Radio value={0}>启用</Radio>
              <Radio value={1}>停用</Radio>
            </Radio.Group>
          </div>
        </FormItem>
      </Modal>
      {/* 修改角色弹窗 */}
      <Modal
        title="修改角色"
        open={rewriteRoleVisible}
        onCancel={handlelRewriteRoleCancel}
        footer={[
          <Button type="primary" shape="round" onClick={handlRewriteRoleeOk}>
            确认
          </Button>,
          <Button shape="round" onClick={handlelRewriteRoleCancel}>
            取消
          </Button>,
        ]}
        className="addRole_wrap"
        destroyOnClose={true}
      >
        <FormItem>
          <div className="item">
            <span>
              <b style={{ color: "red" }}>*</b>角色名称：
            </span>
            <Input
              onChange={(value) => {
                handlelRewriteInputChange(value);
              }}
              value={rewriteReqData.rolename}
              placeholder="角色名称"
              name="rolename"
              className="input"
            />
          </div>
        </FormItem>
        <FormItem>
          <div className="item">
            <span>
              {" "}
              <b style={{ color: "red" }}>*</b>角色分组：
            </span>
            <Select
              placeholder="角色名称"
              style={{ width: 300, marginRight: 20 }}
              value={rewriteReqData.groupname}
              onChange={(value) => {
                handlelRewriteSelectChange(value);
              }}
            >
              <Option value="人事">人事</Option>
              <Option value="运营">运营</Option>
              <Option value="客服">客服</Option>
              <Option value="采购">采购</Option>
              <Option value="仓储">仓储</Option>
              <Option value="批发">批发</Option>
              <Option value="技术">技术</Option>
              <Option value="管理员">管理员</Option>
              <Option value="财务">财务</Option>
              <Option value="质量">质量</Option>
            </Select>
          </div>
        </FormItem>
        <FormItem>
          <div className="item">
            <span>
              {" "}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b style={{ color: "red" }}>*</b>状态：
            </span>
            <Radio.Group
              name="deleted"
              onChange={(value) => {
                handlelRewriteInputChange(value);
              }}
              value={rewriteReqData.deleted}
            >
              <Radio value={0}>启用</Radio>
              <Radio value={1}>停用</Radio>
            </Radio.Group>
          </div>
        </FormItem>
      </Modal>
      {/* 角色添加成功后的弹窗 */}
      <Modal
        title="提示"
        open={addOKTipVisible}
        onCancel={addOKTipCancel}
        className="addRoleTip_wrap"
        destroyOnClose={true}
        footer={false}
      >
        <p>
          角色 <span>{currentAddRole.rolename}</span>{" "}
          添加成功，你现在可以为角色设置权限了。
        </p>
        <Divider />
        <div className="addTipFooter">
          <Button
            shape="round"
            onClick={() => {
              addOKTipCancel();
            }}
          >
            稍后设置
          </Button>
          <Button shape="round" style={{ marginLeft: "20px" }} type="primary">
            <Link to={setRightobj}>立即设置</Link>
          </Button>
        </div>
      </Modal>
      <Modal
        title="角色管理-帮助中心"
        footer={null}
        open={helpVisiable}
        destroyOnClose={true}
        onCancel={helpModalChange}
      >
        <p>1，点击"添加角色"按钮，选择角色组创建角色</p>
        <p>2，点击"编辑"按钮，修改角色信息</p>
        <p>3，点击"设置权限"按钮，为该角色配置权限</p>
        <p>4，点击"设置用户"按钮，为该角色绑定用户</p>
        <div style={{ textAlign: "center" }}>
          <Button type="primary" shape="round" onClick={helpModalChange}>
            我知道了
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default RoleManagement;



// WEBPACK FOOTER //
// ./src/pages/roleManagement/roleManagement.js